import PrimeVue from 'primevue/config';
import {} from 'vue';
import { theme } from './theme';
export const primeVueConfig = {
    theme
};
export function registerPrimeVue(app) {
    app.use(PrimeVue, primeVueConfig);
}
